module.exports = __webpack_public_path__ + "img/google-log.17c001dd.png";